import { c as _c } from "react/compiler-runtime";
import * as React from "react";
import { cn } from "../utils";
interface DateRangeInputProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
  displayValue: string | null;
  active?: boolean;
}
const DateRangeInput = React.forwardRef<HTMLButtonElement, DateRangeInputProps>((t0, ref) => {
  const $ = _c(14);
  let className;
  let displayValue;
  let label;
  let props;
  let t1;
  if ($[0] !== t0) {
    ({
      label,
      displayValue,
      active: t1,
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = displayValue;
    $[3] = label;
    $[4] = props;
    $[5] = t1;
  } else {
    className = $[1];
    displayValue = $[2];
    label = $[3];
    props = $[4];
    t1 = $[5];
  }
  const active = t1 === undefined ? false : t1;
  const t2 = active ? "border border-surface-highlight-interactive bg-surface-base-secondary text-surface-highlight-interactive shadow-[0_0_0_2px_var(--color-open-water-100)]" : "bg-surface-base-secondary text-text-primary hover:bg-surface-base-tertiary";
  let t3;
  if ($[6] !== className || $[7] !== t2) {
    t3 = cn("flex h-[46px] flex-1 items-center justify-center rounded-lg p-2", "typography-component-sm-medium text-center transition-colors", t2, className);
    $[6] = className;
    $[7] = t2;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const t4 = displayValue ?? label;
  let t5;
  if ($[9] !== props || $[10] !== ref || $[11] !== t3 || $[12] !== t4) {
    t5 = <button ref={ref} type="button" data-slot="date-range-input" className={t3} {...props}>{t4}</button>;
    $[9] = props;
    $[10] = ref;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
});
DateRangeInput.displayName = "DateRangeInput";
export { DateRangeInput };
export type { DateRangeInputProps };